export default __webpack_public_path__ + "static/media/magicsquare.a24844ac.png";